import * as React from "react";

export const LancamentoDiarioBottom = () => {
  return (
    <React.Fragment>
      <div></div>
    </React.Fragment>
  );
};

export default LancamentoDiarioBottom;
